<div class="dialogContainer" *ngIf="createStudent && !waiting">
    <div class="flexBeetwen">
        <p mat-dialog-title class="headline5">{{ 'admin.createStudent.title' | translate }}</p>
        <button mat-button class="buttonDialogClose" mat-dialog-close>
            <mat-icon class="clearIcon">close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <form [formGroup]="studentForm">
            <mat-form-field class="inputFullWidth2" appearance="fill">
                <mat-label>{{ 'forms.user.emailInput' | translate}}</mat-label>
                <input id="emailInput" formControlName="email" type="email" matInput required>
            </mat-form-field>
            
            <mat-form-field class="inputFullWidth2" appearance="fill">
                <mat-label>{{ 'forms.user.name' | translate}}</mat-label>
                <input id="nameInput" formControlName="nombre" type="text" matInput required>
            </mat-form-field>
            
            <mat-form-field class="inputFullWidth2" appearance="fill">
                <mat-label>{{ 'forms.user.lastName' | translate}}</mat-label>
                <input id="lastNameInput" formControlName="apellido" type="text" matInput required>
            </mat-form-field>
            
            <mat-form-field class="inputFullWidth2" appearance="fill">
                <mat-label>{{ 'forms.user.secondLastname' | translate}}</mat-label>
                <input id="secondlastNameInput" formControlName="segundoApellido" type="text" matInput>
            </mat-form-field>
            
        </form>
    </mat-dialog-content>
        
        <button color="primary" [disabled]="!studentForm.valid || waiting" mat-raised-button class="buttonDialog" (click)="onSubmit()">{{ 'admin.createStudent.button' | translate }}</button>
</div>

<app-loading *ngIf="waiting" [showText]="false"></app-loading>

<div class="dialogContainer450" *ngIf="success">
    <div class="centerText">
        <mat-icon class="logo" svgIcon="done"></mat-icon>
        <p mat-dialog-title class="headline5">{{ 'admin.createStudent.success.title' | translate }}</p>
    </div>
    <p class="subtitle1">{{ 'admin.createStudent.success.text' | translate }}</p>
    <button mat-raised-button color="primary" class="buttonDialog" [mat-dialog-close]="true" cdkFocusInitial >{{ 'admin.createStudent.success.button' | translate }}</button>
</div>